import * as actions from '../actionTypes';

export const setDoneLoading = (value) => ({
  type: actions.SET_DONE_LOADING,
  payload: value,
});

export const setAttendanceModified = (value) => ({
  type: actions.SET_ATTENDANCE_MODIFIED,
  payload: value,
});